<div class="loader" *ngIf="isLoading">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>
<div class="account-parent" *ngIf="!isLoading">
  <div class="back-step" *ngIf="currentScreenFlow != AccountSetupFlow.confirmEmail && currentScreenFlow != AccountSetupFlow.success">
    <a href="javascript:void(0)" (click)="previousScreen()">
      <adp-label labelKey="Signup_Create_Account_BackStep_Text"></adp-label>
    </a>
  </div>
  <div class="account-setup" *ngIf="currentScreenFlow === AccountSetupFlow.confirmEmail">
    <div class="row">
      <div class="col-12">
        <div class="heading">
          {{heading}} <mat-icon class="close-icon" (click)="onClose()">close</mat-icon>
        </div>
      </div>
    </div>
    <div *ngIf="currentScreenFlow === AccountSetupFlow.confirmEmail">
      <app-email-confirmation-flow [emailAddress]="emailAddress" (emailConfirmed)="emailConfirmed()"></app-email-confirmation-flow>
    </div>
  </div>

  <div *ngIf="currentScreenFlow === AccountSetupFlow.password">
    <app-password-setup (passwordChanged)="passwordChanged($event)"></app-password-setup>
  </div>
  <div *ngIf="currentScreenFlow === AccountSetupFlow.extraInformation">
    <pgh-extra-information
      [firstName]="firstName" [lastName]="lastName" [phoneNumber]="phoneNumber"
      [showOtpScreen]="showOtpScreen"
      (extraInformationComplete)="extraInformationComplete($event)"
      (sendOtpComplete)="showOtpScreen = $event">
    </pgh-extra-information>
  </div>    
  <div *ngIf="currentScreenFlow === AccountSetupFlow.success">
    <app-success-screen (changeHeading)="changeHeading()"></app-success-screen>
  </div>
</div>

